import { vec3 } from 'gl-matrix';

/**
 * Created by xujie3949 on 2017/5/10.
 * 实现贝塞尔曲线离散化,采用二分逼近法
 */
class Curve {
    constructor(p0, c0, c1, p1) {
        this._p0 = p0;
        this._c0 = c0;
        this._c1 = c1;
        this._p1 = p1;
    }

    getVertexes(p0, c0, c1, p1, threshold, vertexes) {
        const q1 = [];
        vec3.lerp(q1, p0, c0, 0.5);

        const q2 = [];
        vec3.lerp(q2, c0, c1, 0.5);

        const q3 = [];
        vec3.lerp(q3, c1, p1, 0.5);

        const q4 = [];
        vec3.lerp(q4, q1, q2, 0.5);

        const q5 = [];
        vec3.lerp(q5, q2, q3, 0.5);

        const q6 = [];
        vec3.lerp(q6, q4, q5, 0.5);

        const d1 = this.getDistance(p0, p1, q1);
        const d4 = this.getDistance(p0, p1, q4);
        const d5 = this.getDistance(p0, p1, q5);
        const d3 = this.getDistance(p0, p1, q3);

        const vp0p1 = [];
        vec3.subtract(vp0p1, p1, p0);

        const vp0q1 = [];
        vec3.subtract(vp0q1, q1, p0);

        const vp0q4 = [];
        vec3.subtract(vp0q4, q4, p0);

        const vp0q5 = [];
        vec3.subtract(vp0q5, q5, p0);

        const vp0q3 = [];
        vec3.subtract(vp0q3, q3, p0);

        const dot1 = vec3.dot(vp0q1, vp0p1);
        const dot4 = vec3.dot(vp0q4, vp0p1);
        const dot5 = vec3.dot(vp0q5, vp0p1);
        const dot3 = vec3.dot(vp0q3, vp0p1);

        let length = vec3.length(vp0p1);
        length *= length;

        if (d1 > threshold || d4 > threshold || d5 > threshold || d3 > threshold ||
            dot1 < 0 || dot4 < 0 || dot5 < 0 || dot3 < 0 ||
            dot1 > length || dot4 > length || dot5 > length || dot3 > length) {
            this.getVertexes(p0, q1, q4, q6, threshold, vertexes);
            this.getVertexes(q6, q5, q3, p1, threshold, vertexes);
        } else {
            vertexes.push(
                [p0[0], p0[1], p0[2]],
                [p1[0], p1[1], p1[2]]
            );
        }
    }

    getDistance(p1, p2, p) {
        const vp1p2 = [];
        vec3.subtract(vp1p2, p2, p1);

        const vp1p = [];
        vec3.subtract(vp1p, p, p1);

        const lp1p2 = vec3.length(vp1p2);
        const lp1p = vec3.length(vp1p);

        const dotRes = vec3.dot(vp1p, vp1p2);

        if (dotRes === 0) {
            return lp1p;
        }
        
        const cos = dotRes / (lp1p * lp1p2);
        const distance = lp1p * Math.sin(Math.acos(cos));
        return distance;
    }

    approximate(threshold) {
        const vertexes = [];
        this.getVertexes(this._p0, this._c0, this._c1, this._p1, threshold, vertexes);
        return vertexes;
    }
}

module.exports = Curve;

